export const API_MULTIPLY_CALLS_TIMEOUT_MS = 1000;

export const API_MULTIPLY_CALLS_DEBOUNCE_MS = 300;

export const API_MULTIPLY_CALLS_TIMEOUT_AUTOCOMPLETE_MS = 300;
